import React, { FC } from "react";
import { Login } from "./Login";
import { LoginAction } from "./LoginAction";

export const LoginCallbackPage: FC = () => {
  return <Login action={LoginAction.LoginCallback} />;
};
